import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import freeTick from "../../Assets/Images/freeTick.svg";
import premTick from "../../Assets/Images/premTick.svg";
import enterTick from "../../Assets/Images/enterTick.svg";
import { useTranslation } from "react-i18next";

const CompareRow = ({ name, title, free, prem, enter }) => {
  const { t } = useTranslation();

  return (
    <tr>
      <td
        className={`${
          title === true
            ? "productSansBold text_24 w_20  line_height_1_813"
            : "productSansLight text_18 "
        } pe-3`}
      >
        {t(name)}
      </td>
      <td className="text-center">
        {free ? <img alt="freetick" src={freeTick} /> : null}
      </td>
      <td className="text-center">
        {prem ? <img alt="premtick" src={premTick} /> : null}
      </td>
      <td className="text-center border-0">
        {enter ? <img alt="entertick" src={enterTick} /> : null}
      </td>
    </tr>
  );
};

export default CompareRow;
